<!--
 * @Author: caoyingming 1046659469@qq.com
 * @Date: 2022-08-22 09:42:42
 * @LastEditors: caoyingming 1046659469@qq.com
 * @LastEditTime: 2022-08-22 09:53:45
 * @FilePath: /genetron-web/genetron-h5/src/views/reportQuery/testingExplain.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  <div class="testingExplain">
    <div class="item-box">
      <h1>检测方法说明</h1>
      <div class="show-box"></div>
      <div class="content">
        Onco
        PanScanTM利用探针杂交捕获技术和Illumina高通量测序（NGS）方法检测831个基因的全外显子区和部分内含子区域；检测结果包含：点突变、短片段插入缺失突变、拷贝数变异及基因重排等变异类型，可提供肿瘤突变负荷（TMB）和微卫星不稳定性（MSI）等分析结果；为泛实体瘤个性化精准诊疗提供分子分型、预后评估、靶向用药、免疫治疗、遗传风险提示、化疗用药等参考信息。
      </div>
    </div>
    <div class="item-box">
      <h1>局限性说明</h1>
      <div class="show-box"></div>
      <div class="content">
        ·
        任何与患者护理和治疗选择有关的决定都应基于治疗医生的独立判断，并应考虑到与患者有关的所有信息，包括但不限于患者和家族史、直接体检和其他测试。泛生子基因不负责与测试结果有关的诊断、预后或治疗的医学判断。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GenetronWebTestingExplain",

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="less" scoped>
.show-box {
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(58, 74, 134, 0) 0%,
    rgba(58, 74, 134, 0.06) 100%
  );
}
.testingExplain {
  .item-box {
    width: 343px;
    background: #f4f8fd;
    border-radius: 10px;
    margin: 0 auto;
    margin-bottom: 20px;
    padding-bottom: 30px;
    h1 {
      height: 70px;
      font-size: 18px;
      text-indent: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #2f354d;
      line-height: 70px;
    }
    .content {
      margin-top: 10px;
      padding: 0 24px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #5f697d;
      line-height: 30px;
      word-break: break-all;
      text-align: justify;
      text-justify: newspaper;
    }
  }
}
</style>